import { Component, OnInit, inject } from '@angular/core';
import { ICONS } from '../../utils';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'ft-icon-select',
    templateUrl: './icon-select.component.html',
    styleUrls: ['./icon-select.component.scss'],
    imports: [
        MatDialogTitle,
        
        MatDialogContent,
        MatIcon,
        MatTooltip,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
    ]
})
export class IconSelectComponent implements OnInit {
	icon = inject(MAT_DIALOG_DATA);

	icons = [];
	selectedIcon: string;

	ngOnInit(): void {
		this.icons = ICONS;
	}
}
